import axios from 'axios';
import { BASE_SETTINGS_URL } from '../components/constants';


// Create a new standard question
export const createSQ = async (data) => {
    const response = await axios.post(`${BASE_SETTINGS_URL}/sq/`, data);
    return response.data;
};

// Get all standard questions for a specific task
export const getSQByTaskId = async (taskId) => {
    const response = await axios.get(`${BASE_SETTINGS_URL}/sq/task/${taskId}`);
    return response.data;
};

// Update an existing standard question
export const updateSQ = async (data) => {
    const response = await axios.put(`${BASE_SETTINGS_URL}/sq/`, data);
    return response.data;
};

// Delete a standard question
export const deleteSQ = async (id) => {
    const response = await axios.delete(`${BASE_SETTINGS_URL}/sq/`, { data: { id } });
    return response.data;
};

// Get all standard questions
export const getAllSQ = async () => {
    const response = await axios.get(`${BASE_SETTINGS_URL}/sq/`);
    return response.data;
};

export const reorderSQ = async (orderList) => {
  const response = await axios.put(`${BASE_SETTINGS_URL}/sq/reorder`, orderList);
  return response.data;
};
